export default () => ({
  entities: 'agendas',
  agendas: [],
  lastday: null,
  ishidden: false
})



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/agendas-statistics/resources/data.js